import React from 'react';
import { useProto } from '../../contexts/PrototypeContext';
import { Segmented } from './Segmented';
import { Toggle } from '../shared/Toggle';
import type { Device, ViewMode } from '../../types/volunteer';
export function PrototypeBar() {
  const {
    state,
    actions
  } = useProto();
  return <header className="flex h-14 shrink-0 items-center gap-4 border-b border-proto-line bg-white px-4 font-proto" data-id="element-394" data-mp="1rxvdcxys4gua">
      <div className="min-w-0" data-id="element-395" data-mp="1mzamhp5f39ii">
        <p className="truncate text-sm font-semibold text-proto-ink" data-id="element-396" data-mp="1mzk3wocec8cl">Volunteer Registration Discount</p>
        <p className="truncate text-xs text-proto-muted" data-id="element-397" data-mp="1i5fttw7u3k7a">i9 Sports · interactive prototype for product review</p>
      </div>
      <div className="ml-auto flex items-center gap-3" data-id="element-398" data-mp="189cv70c6y3p3">
        <Segmented<ViewMode> label="Experience" value={state.view} onChange={actions.setView} options={[{
        value: 'connect',
        label: 'Connect · Franchisee'
      }, {
        value: 'customer',
        label: 'Registration · Customer'
      }]} data-id="element-399" data-mp="18axnskey3ckb" />
        {state.view === 'customer' && <Segmented<Device> label="Device" value={state.device} onChange={actions.setDevice} options={[{
        value: 'mobile',
        label: 'Mobile'
      }, {
        value: 'desktop',
        label: 'Desktop'
      }]} data-id="element-400" data-mp="1hhzea3i1o9y9" />}
        <div className="flex items-center gap-2 border-l border-proto-line pl-3" data-id="element-401" data-mp="1vhqv0bzy44fy">
          <span id="annot-label" className="whitespace-nowrap text-xs font-medium text-proto-muted" data-id="element-402" data-mp="1vfnzjcg0xj3u">
            Annotations
          </span>
          <Toggle size="sm" checked={state.showAnnotations} onChange={actions.toggleAnnotations} label="Show annotations" data-id="element-403" data-mp="1mhvfjuzcxna4" />
        </div>
      </div>
    </header>;
}